import { ENUM__color_bright } from '@/enums/ENUM__color_bright';
import { UTILS__crypto } from '@shared/utils/crypto/UTILS__crypto';

function get_color(value: string) {
  let hash = UTILS__crypto.djb2.from_string(value);

  hash = Math.abs(hash);

  let COLORS_LIST = Object.values(ENUM__color_bright);

  return COLORS_LIST[hash % Object.values(ENUM__color_bright).length];
}

export function render_table_cell_as_chip_colorized(value: string, value_localized: string) {
  const type_color = get_color(value);
  return (
    <div className="w-full flex items-center justify-start">
      <div className={`rounded-lg border flex-center border-dashed  px-1.5`} style={{ borderColor: type_color }}>
        <span style={{ color: type_color }} className="text-[10px]">
          {value_localized}
        </span>
      </div>
    </div>
  );
}
